'use client';

import NextLink from 'next/link';
import { usePathname } from 'next/navigation';
import { NavItem } from '../../Header.types';
import { css } from '@onbeam/business-styled-system/css';
import { HoverCard } from '@/components';
import { desktopNavItemStyles } from './DesktopNavItem.styles';
import { isActivePath } from '../../Header.utils';
import { SubNavItem } from '../../SubNavItem';
import { subMenuStyles } from '../../SubNavItem/SubNavItem.styles';
import { ArrowDiagonalIcon } from '@onbeam/icons/business';

export const DesktopNavItem = ({
  href,
  label,
  isExternal,
  subMenu,
}: NavItem) => {
  const pathname = usePathname();

  const Item = href ? (
    <NextLink
      href={href}
      target={isExternal ? '_blank' : '_self'}
      rel="noopener noreferrer"
      data-active={isActivePath(pathname, href)}
      className={desktopNavItemStyles}
    >
      <div
        data-is-external={isExternal}
        className={css({
          mt: '[0.125rem]',
          '&[data-is-external="true"]': {
            display: 'inline-flex',
            alignItems: 'center',
            position: 'relative',
            transitionProperty: 'transform',
            transitionDuration: '[250ms]',
            transitionTimingFunction: 'ease',

            _groupHover: {
              transform: 'translateX(-16px)',
            },
          },
        })}
      >
        <span>{label}</span>
        {isExternal && (
          <ArrowDiagonalIcon
            height={16}
            width={16}
            className={css({
              position: 'absolute',
              top: '[50%]',
              right: '0',
              pr: '0.5',
              transform: 'translate(100%, -50%)',
            })}
          />
        )}
      </div>
    </NextLink>
  ) : (
    <button type="button" className={desktopNavItemStyles}>
      {label}
    </button>
  );

  if (!subMenu) return Item;

  const subMenuClasses = subMenuStyles({ variant: subMenu.variant });

  // TODO: Currently subnavs dont support keyboard navigation
  return (
    <HoverCard trigger={Item}>
      <div className={subMenuClasses.root}>
        {subMenu?.items.map((item) => (
          <SubNavItem {...item} variant={subMenu.variant} key={item.label} />
        ))}
      </div>
    </HoverCard>
  );
};
